import { themes } from "@superego/themes";

export const { breakpoints, colors, dark, light, vars } = themes;
